import React from 'react';
import '../../styles/SolucionesPublicitarias.css';

const BehealthTv = () => {
    return (
        <section className="Behealth-tv-section py-5">
            <div className="container">
                <div className='row justify-content-center align-items-center m-1 mt-5'>
                    <div className='col-lg-10 col-md-12'>
                        <div className='text-center pb-2 mb-5' data-aos="zoom-in">
                            <img src="assets/tv-3.png" alt="" className='img-fluid img-filter mb-5 behealth-tv-logo' />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-12'>

                        <div className='img-behealth-tv position-relative z-4'>

                            <div className='mt-5' data-aos="zoom-in">

                                <img src="assets/tv-1.png" alt="" className='img-filter position-absolute top-50 start-50 translate-middle image-tv' />

                                <div className='behealth-video-container position-absolute top-50 start-50 translate-middle'>
                                    <video className='behealth-video' controls >
                                        <source src="assets/BeHealth-tv.mp4" type="video/mp4" />
                                        Tu navegador no soporta el video.
                                    </video>
                                </div>
                            </div>
                        </div>

                        <div className='row align-items-center col-behealth-tv shadow-lg pb-3' data-aos="fade-up">
                            <div className='col text-center'>
                                <img src="assets/tv-2.png" alt="" className='img-fluid img-filter' />
                            </div>
                            <div className='col-md-3'>
                                <p>
                                    Sintoniza <span className='fw-bold'>ABC Puerto Rico por:</span>
                                </p>
                            </div>
                            <div className='col-md-3'>
                                <ul>
                                    <li>Canal 15 de Liberty</li>
                                    <li>20 en Dish</li>
                                </ul>
                            </div>
                            <div className='col-md-3'>
                                <ul>
                                    <li>172 en DirecTV</li>
                                    <li>5.1 por antena libre</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BehealthTv;